export const FETCH_MontantInvest_REQUEST = 'FETCH_MontantInvest_REQUEST';
export const FETCH_MontantInvest_SUCCESS = 'FETCH_MontantInvest_SUCCESS';
export const FETCH_MontantInvest_FAILURE = 'FETCH_MontantInvest_FAILURE';
export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';